export default __webpack_public_path__ + "static/media/35aabae47bf377ce8cc920e8ec38c6451600253543851.1fbefda2.webp";